import { Linkedin, Twitter } from 'lucide-react';
import { CATEGORIES, DATA_FILTERS } from './constants';
import { slugify } from '@/utils/slugify';

export const unauthenticatedItems = [
  { label: 'Pricing', path: '/', hash: '#pricing' },
  { label: 'Clients', path: '/', hash: '#clients' },
  { label: 'Who We Serve', path: '/', hash: '#who-we-serve' },
  { label: 'Contact', path: '/contact' },
];

export const authenticatedItemsMobile = [
  { label: 'Home', path: '/home' },
  {
    label: 'Research',
    path: 'category/gas-lng-carbon/all',
  },
  { label: 'Data', path: '/data' },
  {
    label: 'Settings',
    path: '/settings',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export const authenticatedItemsDesktop = [
  { label: 'Home', path: '/home' },
  {
    label: 'Research',
    path: '/category/gas-lng-carbon/all',
  },
  { label: 'Data', path: '/data' },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export const footerLinks = [
  { label: 'Home', path: '/home' },
  {
    label: 'Research',
    path: '#',
    children: CATEGORIES.map((category) => ({
      label: category.name,
      path: `/category/${slugify(category.name)}`,
    })),
  },
  {
    label: 'Data',
    path: '#',
    children: DATA_FILTERS.map((filter) => ({
      label: filter.name,
      path: `/data/${filter.id}`,
    })),
  },
  {
    label: 'Account',
    path: '#',
    children: [
      { label: 'Settings', path: '/settings' },
      { label: 'Contact', path: '/contact' },
    ],
  },
];

export const socialLinks = [
  { url: 'https://linkedin.com/company/79815874', label: 'LinkedIn', icon: Linkedin },
  { url: 'https://x.com/EklipxResearch', label: 'X (Twitter)', icon: Twitter },
];
